import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { useNavigate } from 'react-router-dom';
import TitlePage from '../../Shared/TitlePage';
import { dataService } from '../../../Services/data/data.service';
import { Fab, IconButton, Divider, Typography, Box, Grid2, Dialog, DialogActions, DialogTitle, DialogContent, DialogContentText, Button, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { ArrowUp, CalendarClock, Trash2, Pencil, Plus, Search, Factory, X } from 'lucide-react';
import { Spin } from "react-cssfx-loading";
import { toast } from 'react-toastify';
import DateRangePicker from '../../Shared/DateSelection/DateRangePicker';
import { ProjectFilter, GraphFilterTypes } from '../../../Config/constants';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import BackToTopButton from '../../Shared/Buttons/BackToTopButton';


function GraphsOverviewPage(props) {
    const classes = useStyles();
    const navigate = useNavigate();
    const [graphList, setGraphList] = useState([]);
    const [originalGraphList, setOriginalGraphList] = useState([]); // List of all graphs
    const [allGraphConfigurations, setAllGraphConfigurations] = useState([]);
    const initialProjectList = useRef([]);
    const firstLoad = useRef(false);
    const [loadAmount, setLoadAmount] = useState(21);
    const [deleteGraphId, setDeleteGraphId] = useState(null);
    const [visibleProjectFilter, setVisibleProjectFilter] = useState(ProjectFilter.ALLPROJECTS);

    // General

    // Filtering
    const [filters, setFilters] = useState(props.activeFilters.graphOverviewFilters);
    const [filteringDateRange, setFilteringDateRange] = useState(false);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();

    const currentDate = new Date();
    const [loading, setLoading] = useState(true);
    const [delopen, setDelOpen] = useState(false);

    const loadMore = () => {
        // if (window.innerHeight + document.documentElement.scrollTop === document.scrollingElement.scrollHeight) {
        //     let TempLoadAmount = loadAmount + 9;
        //     if (firstLoad.current) {
        //         dataService.getAllUserCompanyProjects(props.Login.userid, loadAmount + 9, 9).then(results => {
        //             setGraphList(sortProjectsOnFinished(initialProjectList.current.concat(results)));
        //             setOriginalGraphList(sortProjectsOnFinished(initialProjectList.current.concat(results)));
        //         });
        //         firstLoad.current = false;
        //     }
        //     else {
        //         dataService.getAllUserCompanyProjects(props.Login.userid, loadAmount + 9, 9).then(results => {
        //             if (results.length > 0) {
        //                 setGraphList(sortProjectsOnFinished(originalGraphList.concat(results)));
        //                 setOriginalGraphList(sortProjectsOnFinished(originalGraphList.concat(results)));
        //             }
        //         });
        //     }
        //     setLoadAmount(TempLoadAmount);
        //     window.removeEventListener('scroll', loadMore);
        // }
    }

    const reload = () => {
        Promise.all([
            dataService.getAllUserCompanyProjects(props.Login.userid, 0, loadAmount),
            dataService.getAllGraphConfigurationsByCompanyIdList(props.Login.userid),
        ]).then((results) => {
            var userCompanyProjectResults = results[0];
            var graphConfigurationsByCompanyIds = results[1];

            if (userCompanyProjectResults !== null && userCompanyProjectResults !== undefined) {
                setGraphList(sortProjectsOnFinished(userCompanyProjectResults));
                setOriginalGraphList(sortProjectsOnFinished(userCompanyProjectResults));
                window.addEventListener('scroll', loadMore);
                initialProjectList.current = userCompanyProjectResults;
                firstLoad.current = true;
            }

            if (graphConfigurationsByCompanyIds !== null && graphConfigurationsByCompanyIds !== undefined) {
                // Sort results by the most recent date in either updatedOn or insertedOn
                const sortedResults = graphConfigurationsByCompanyIds.sort((a, b) => {
                    // Get the date to compare for each object (updatedOn if available, otherwise insertedOn)
                    const dateA = new Date(a.updatedOn || a.insertedOn);
                    const dateB = new Date(b.updatedOn || b.insertedOn);

                    // Sort in descending order (most recent first)
                    return dateB - dateA;
                });
                setGraphList(sortedResults);
                setOriginalGraphList(sortedResults);
            }

        }).catch((error) => {
            toast.error(`A problem occured while fetching the data`, { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
            console.log('Error: ', error)
        }).finally(() => {
            setLoading(false);

        });

    }

    useEffect(() => {
        Promise.all([
            dataService.getAllUserCompanyGraphConfigurations(props.Login.userid),
        ]).then((results) => {
            var graphConfigurationsByCompanyIds = results[0];

            // if (userCompanyProjectResults !== null && userCompanyProjectResults !== undefined) {
            //     setGraphList(sortProjectsOnFinished(userCompanyProjectResults));
            //     setOriginalGraphList(sortProjectsOnFinished(userCompanyProjectResults));
            //     window.addEventListener('scroll', loadMore);
            //     initialProjectList.current = userCompanyProjectResults;
            //     firstLoad.current = true;
            // }

            if (graphConfigurationsByCompanyIds !== null && graphConfigurationsByCompanyIds !== undefined) {
                // Sort results by the most recent date in either updatedOn or insertedOn
                const sortedResults = graphConfigurationsByCompanyIds.sort((a, b) => {
                    // Get the date to compare for each object (updatedOn if available, otherwise insertedOn)
                    const dateA = new Date(a.updatedOn || a.insertedOn);
                    const dateB = new Date(b.updatedOn || b.insertedOn);

                    // Sort in descending order (most recent first)
                    return dateB - dateA;
                });

                // setGraphList(sortedResults);
                filterGraphs(filters, sortedResults);
                setOriginalGraphList(sortedResults);
            }

        }).catch((error) => {
            toast.error(`A problem occured while fetching the data`, { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
            console.log('Error: ', error)
        }).finally(() => {
            setLoading(false);
        });

    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        window.addEventListener('scroll', loadMore);
    }, [loadAmount]); // eslint-disable-line react-hooks/exhaustive-deps

    const getPercentage = (fromDate, toDate) => {
        let fromDateDate = new Date(fromDate);
        let toDateDate = new Date(toDate);
        let difference = currentDate.getTime() - fromDateDate.getTime();
        let percentage = (difference / (toDateDate.getTime() - fromDateDate.getTime())) * 100;
        return percentage;
    }

    const handleDialogOpenDel = (id) => {
        setDeleteGraphId(id);
        setDelOpen(true);
    }

    const deleteGraph = (graphId) => {
        dataService.deleteGraphConfiguration(graphId, props.Login.userid).then((result) => {
            toast.success(`The graph was removed`, { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
            setDeleteGraphId(null);
            setDelOpen(false);
        }).catch((error) => {
            toast.error(`A problem occured while changing the data`, { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
            console.log('error', error)
        }).finally(() => {
            // remove deleted graph from originalgraphlist && graphlist
            let tempGraphList = [...graphList];
            let tempOriginalGraphList = [...originalGraphList];
            let index = tempGraphList.findIndex(x => x.id === graphId);
            let indexOriginal = tempOriginalGraphList.findIndex(x => x.id === graphId);
            tempGraphList.splice(index, 1);
            tempOriginalGraphList.splice(indexOriginal, 1);
            setGraphList(tempGraphList);
            setOriginalGraphList(tempOriginalGraphList);
        })
    }
    const handleDialogCloseDel = () => {
        setDeleteGraphId(null);
        setDelOpen(false);
    }

    const handleNewGraph = () => {
        navigateToGraphEdit();
    }

    const navigateToGraphEdit = (graphId) => {
        if (graphId) {
            navigate('/modifygraph/' + graphId);
        } else {
            navigate('/modifygraph/new');
        };
    }

    const navigateToGraphDetail = (graphId) => {
        if (graphId) {
            navigate('/graph/' + graphId);
        }
    }

    const sortProjectsOnFinished = (projects) => {
        var results = projects.map(project => {
            let percentage = getPercentage(Date.parse(project.timeRangeBegin), Date.parse(project.timeRangeEnd))
            if (percentage < 100) {
                project.finished = false
            }
            else {
                project.finished = true
            }

            return project
        })

        results = results.sort((a, b) => (a.finished - b.finished))
        return results
    }

    const formatCardDate = (date) => {
        const now = new Date();
        const inputDate = new Date(date);

        // Calculate the difference in years between the current date and the input date
        const yearDiff = now.getFullYear() - inputDate.getFullYear();

        // Check if the date is within the last year
        const isYoungerThanOneYear = yearDiff < 1 || (yearDiff === 1 && now.getMonth() >= inputDate.getMonth() && now.getDate() >= inputDate.getDate());

        // Format the date
        if (isYoungerThanOneYear) {
            const day = String(inputDate.getDate()).padStart(2, '0');
            const month = String(inputDate.getMonth() + 1).padStart(2, '0'); // Months are 0-based
            const hours = String(inputDate.getHours()).padStart(2, '0');
            const minutes = String(inputDate.getMinutes()).padStart(2, '0');

            return `${day}/${month} ${hours}:${minutes}`;
        } else {
            const day = String(inputDate.getDate()).padStart(2, '0');
            const month = String(inputDate.getMonth() + 1).padStart(2, '0');
            const year = inputDate.getFullYear();

            return `${day}/${month}/${year}`;
        }
    };

    const changeVisibleProjects = (value) => {
        setVisibleProjectFilter(value);
    }

    const setDateRange = (startDate, endDate) => {
        setStartDate(startDate);
        setEndDate(endDate);
        if (startDate && endDate) {
            setFilteringDateRange(true);
        } else {
            setFilteringDateRange(false);
        }
    }

    useEffect(() => {
        filterGraphs(filters);
    }, [filteringDateRange, startDate, endDate])

    const handleSetStartDate = (event) => {

        if (event !== startDate) {
            setStartDate(event);
            setDateRange(event, endDate);
        }
    }
    const handleSetEndDate = (event) => {
        if (event !== endDate) {
            setEndDate(event);
            setDateRange(startDate, event);
        }
    }

    const resetDateRangeFilter = () => {
        setDateRange(null, null)
    }

    const updateFilters = (type, event) => {
        let tempFilters = [...filters];
        if (tempFilters.some(x => x.type === type)) {
            let index = tempFilters.indexOf(tempFilters.find(x => x.type === type));
            tempFilters.splice(index, 1);
            tempFilters.unshift({ type: type, filterValue: event.target.value });
        }
        else {
            tempFilters.unshift({ type: type, filterValue: event.target.value });
        }

        props.actions.setGraphOverviewFiltersAction(tempFilters);

        setFilters(tempFilters);
        filterGraphs(tempFilters);
    }

    const filterGraphs = (thisFilters, graphList) => {
        let varFilteredGraphs = graphList ? [...graphList] : [...originalGraphList];
        if (filteringDateRange) {
            varFilteredGraphs = varFilteredGraphs.filter(x => new Date(x.updatedOn || x.insertedOn) > new Date(startDate) && new Date(x.updatedOn || x.insertedOn) < new Date(endDate))
        }

        for (let i = 0; i < thisFilters.length; i++) {
            let filter = thisFilters[i]
            switch (filter.type) {
                case GraphFilterTypes.GENERAL:
                    varFilteredGraphs = varFilteredGraphs.filter(x =>
                        x.companyName.toLowerCase().includes(filter.filterValue.toLowerCase()) ||
                        x.name.toLowerCase().includes(filter.filterValue.toLowerCase())
                    );
                    break;
                default:
                    varFilteredGraphs = varFilteredGraphs.filter(x => x.companyName.toLowerCase().includes(filter.filterValue.toLowerCase()));
                    break;
            }
        }
        setGraphList(varFilteredGraphs);
    }

    const getFilterValue = (type) => {

        let filter = filters.find(x => x.type === type)

        if (filter) {
            return filter.filterValue
        }
        else {
            return ""
        }
    }

    return (
        <React.Fragment>
            {loading &&
                <div className={classes.loadingChart}><Spin width="100px" height="100px" color="#C3996B"></Spin></div>
            }
            <TitlePage Text="Graphs overview" backbutton={true} {...props} />
            <Box className={classes.container}>
                <div className={classes.header} sx={{ paddingBottom: '16px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>
                    <h1>Graph overview</h1>
                </div>
                <div className={classes.tableManagementContainer}>
                    <div className={classes.tableManagementContainer__start}>
                        <div className={classes.searchContainer}>
                            <input placeholder="Search for graphs" className={classes.search__input} type="text" value={getFilterValue(GraphFilterTypes.GENERAL)} onChange={(e) => updateFilters(GraphFilterTypes.GENERAL, e)} />
                            <Search size={16} className={classes.inputIcon} />
                        </div>

                        <DateRangePicker setDateRange={setDateRange} startDate={startDate} endDate={endDate} resetDateRangeFilter={resetDateRangeFilter} handleSetStartDate={handleSetStartDate} handleSetEndDate={handleSetEndDate} />

                        <div className={classes.toggleFilter}>
                            <button onClick={() => changeVisibleProjects(ProjectFilter.ALLPROJECTS)} style={{ width: "144px" }} className={classes.toggleFilter__optionButton}>
                                <p className={classes.toggleFilter__label}>Company graphs</p>
                            </button>
                            <button onClick={() => changeVisibleProjects(ProjectFilter.MYPROJECTS)} style={{ width: "144px" }} className={classes.toggleFilter__optionButton}>
                                <p className={classes.toggleFilter__label}>My graphs</p>
                            </button>
                            <div style={{ transform: visibleProjectFilter === ProjectFilter.ALLPROJECTS ? "translateX(0px)" : "translateX(144px)" }} className={classes.toggleSelected} />
                        </div>
                    </div>
                    <div className={classes.tableManagementContainer__end}>
                        {/* <div className={classes.toggleFilter}>
                            <button onClick={() => handleTableView(TableView.LIST)} style={{ width: "64px" }} className={classes.toggleFilter__optionButton}>
                                <List className={classes.toggleFilter__icon} />
                                <p className={classes.toggleFilter__label}>List</p>
                            </button>
                            <button onClick={() => handleTableView(TableView.GRID)} style={{ width: "64px" }} className={classes.toggleFilter__optionButton}>
                                <LayoutGrid className={classes.toggleFilter__icon} />
                                <p className={classes.toggleFilter__label}>Grid</p>
                            </button>
                            <div style={{ transform: tableViewMode === TableView.LIST ? "translateX(0px)" : "translateX(64px)" }} className={classes.toggleSelected} />
                        </div> */}

                        <button className={classes.tableManagementContainer__primaryIconButton} onClick={() => handleNewGraph()}>
                            <Plus className={classes.iconButton__icon} />
                            Create graph
                        </button>
                    </div>
                </div>
                <Grid2 container spacing={2}>
                    {graphList.filter(project => visibleProjectFilter === ProjectFilter.MYPROJECTS ? (project.insertedByUserId === props.Login.userid || project.updatedByUserId === props.Login.userid) : project.isActive).length === 0 &&
                        <Grid2 size={{ xs: 12, md: 6, lg: 4, xl: 3 }} className={classes.card} sx={{ background: 'rgb(195, 153, 107, 0.15)' }} onClick={() => handleNewGraph()} key={'createNewGraphBlock'}>
                            <Box sx={{ border: "2px dashed #C3996B", height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                                <Plus size="35" style={{ color: "#C3996B", fontSize: "30px" }}></Plus>
                                <Typography variant='h6' color='#C3996B'>Create a graph</Typography>
                            </Box>
                        </Grid2>
                    }
                    {/* <div className={classes.cardGrid}> */}
                    {graphList.filter(project => visibleProjectFilter === ProjectFilter.MYPROJECTS ? (project.insertedByUserId === props.Login.userid || project.updatedByUserId === props.Login.userid) : project.isActive).map(graphConfiguration => (
                        <Grid2 size={{ xs: 12, md: 6, lg: 4, xl: 3 }} className={classes.card} onClick={() => navigateToGraphDetail(graphConfiguration.uniqueId)} key={graphConfiguration.id}>
                            <div className={classes.card__header}>
                                <Tooltip title={graphConfiguration.name} placement="top" disableInteractive>
                                    <h2 className={classes.cardTitle}>
                                        {graphConfiguration.name}
                                    </h2>
                                </Tooltip>

                                <div className={classes.buttonContainer}>
                                    <IconButton
                                        onClick={(event) => {
                                            event.stopPropagation(); // Prevent card's onClick from triggering
                                            handleDialogOpenDel(graphConfiguration.id);
                                        }}
                                        size='small'
                                        style={{ height: "42px", width: "42px", borderRadius: "4px", opacity: "1" }}
                                    >
                                        <Trash2 className={classes.buttonContainer__icon} />
                                    </IconButton>
                                    {graphConfiguration.companyIsActive &&
                                        <IconButton
                                            onClick={(event) => {
                                                event.stopPropagation(); // Prevent card's onClick from triggering
                                                navigateToGraphEdit(graphConfiguration.uniqueId);
                                            }}
                                            size='small'
                                            style={{ height: "42px", width: "42px", borderRadius: "4px", opacity: "1" }}
                                        >
                                            <Pencil className={classes.buttonContainer__icon} />
                                        </IconButton>
                                    }
                                </div>
                            </div>

                            <Divider></Divider>
                            <div className={classes.card__body}>
                                <p className={classes.card__description}>
                                    {graphConfiguration.description}
                                </p>
                            </div>
                            <Divider></Divider>
                            <div className={classes.card__footer}>
                                <div className={classes.card__details}>
                                    <div className={classes.card__date}>
                                        <CalendarClock className={classes.detail__icon} />
                                        {
                                            graphConfiguration.updatedOn === null || graphConfiguration.insertedOn > graphConfiguration.updatedOn ?
                                                formatCardDate(graphConfiguration.insertedOn) :
                                                formatCardDate(graphConfiguration.updatedOn)
                                        }
                                    </div>
                                    <div className={classes.card__company} style={{ lineHeight: '0px' }}>
                                        <Factory className={classes.detail__icon} />
                                        {graphConfiguration.companyName}
                                    </div>
                                </div>
                                <Tooltip title={graphConfiguration.isPublic ? "Published" : "Not published"} placement="top" arrow>
                                    <div
                                        className={`${classes.statusIndicator} ${graphConfiguration.isPublic ? classes.published : classes.notPublished}`}
                                    />
                                </Tooltip>
                            </div>

                        </Grid2>
                    ))}

                </Grid2>

                <BackToTopButton />
            </Box>
            {(delopen && originalGraphList.some(x => x.id === deleteGraphId)) &&
                <Dialog
                    className={classes.dialog}
                    open={delopen}
                    onClose={handleDialogCloseDel}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    classes={{ paper: classes.dialogPaper }}
                >
                    <div className={classes.dialog__head}>
                        <DialogTitle className={classes.dialog__title} id="draggable-dialog-title">
                            Delete graph
                        </DialogTitle>
                        <button onClick={() => handleDialogCloseDel()} className={classes.dialog__closeButton}>
                            <X size={19} />
                        </button>
                    </div>
                    <DialogContent className={classes.dialog__contentContainer}>
                        <div className={classes.dialog__content}>
                            <p className={classes.dialog__subtitle}>Are you sure you want to delete {originalGraphList.find(x => x.id === deleteGraphId).name}?</p>
                        </div>
                    </DialogContent>
                    <DialogActions sx={{ display: 'flex', justifyContent: 'space-between', paddingLeft: '16px', paddingRight: '16px', paddingBottom: "16px" }}>
                        <button className={classes.secondaryButton} onClick={handleDialogCloseDel}>Cancel</button>
                        <button className={classes.deleteButton} onClick={() => deleteGraph(deleteGraphId)}>
                            <Trash2 className={classes.iconButton__icon} />
                            {"Delete"}
                        </button>
                    </DialogActions>
                </Dialog>
            }
        </React.Fragment>
    )
}

export default GraphsOverviewPage;

const useStyles = makeStyles((theme) => ({
    container: {
        boxSizing: "border-box",

        borderRadius: "8px",
        maxWidth: "90%",
        marginRight: "auto",
        marginLeft: "auto",
        marginTop: "148px",
        marginBottom: "24px",
    },
    deleteButton: {
        padding: "0 16px",
        paddingLeft: "8px",
        border: "1px solid #D84949  !important",
        borderRadius: "4px",
        fontSize: "16px",
        color: "#D84949 !important",
        backgroundColor: "transparent",
        display: "flex",
        alignItems: "center",
        transition: "all 0.2s ease-in-out",
        "&:hover": {
            border: "1px solid #D84949",
            backgroundColor: "#D84949",
            color: "white  !important",
            cursor: "pointer",
        }
    },
    header: {
        width: "100%",
        height: "40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: "16px",
    },

    loadingChart: {
        height: '100vh',
        width: '100%',
        top: '0px',
        position: 'fixed',
        zIndex: '999',
        borderRadius: "8px",
        backgroundColor: 'rgba(156,156,156,0.5)',
        display: 'flex',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',
    },
    headerButtonContainer: {
        width: "100%",
        display: "flex",
        justifyContent: "flex-end",

        marginBottom: "16px",
    },

    tableManagementContainer: {
        width: "100%",
        height: "fit-content",

        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "8px",
        flexWrap: "wrap-reverse",

        marginBottom: "8px",
    },

    tableManagementContainer__start: {
        width: "fit-content",

        display: "flex",
        alignItens: "center",
        gap: "8px",

        flexWrap: "wrap",
    },

    searchContainer: {
        width: "240px",
        position: 'relative',
    },

    search__input: {
        width: '100%',
        height: '32px',
        boxSizing: 'border-box',

        display: 'flex',
        alignItems: 'center',

        padding: '0px 8px',
        paddingRight: '32px',

        borderRadius: "4px",
        border: "1px solid #DCDCDC",

        fontSize: '14px',
        fontFamily: 'Lato, sans-serif',
        fontWeight: 'normal',
        color: "#0C0E29",

        backgroundColor: "#FFFFFF",

        "&:focus": {
            outline: "none",
            border: "1px solid #C3996B",
        },
    },

    inputIcon: {
        color: "#0C0E29",
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        right: '8px',
    },

    tableManagementContainer__end: {
        width: "fit-content",

        display: "flex",
        alignItems: "center",
        gap: "8px",
    },

    toggleFilter: {
        height: "32px",
        boxSizing: "border-box",

        position: "relative",

        display: "flex",
        alignItems: "center",

        backgroundColor: "#DCDCDC",
        borderRadius: "4px",

        padding: "1px",
    },

    toggleFilter__optionButton: {
        height: "100%",

        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "6px",

        border: "none",
        borderRadius: "3px",

        color: "#0C0E29",
        backgroundColor: "transparent",

        transition: "all ease-in-out 0.2s",

        zIndex: "1",

        "&:hover": {
            // backgroundColor: "#DCDCDC",
            cursor: "pointer",
        },

    },

    toggleFilter__icon: {
        height: "16px",
        width: "16px",
        display: "block",

        color: "#0C0E29",

        strokeWidth: "1.4px",
    },

    toggleFilter__label: {
        fontFamily: "Lato, sans-serif",
        fontSize: "14px",
        margin: "0",
    },

    toggleSelected: {
        width: "calc(50% - 1px)",
        height: "30px",
        position: "absolute",
        transition: "transform 0.2s",

        backgroundColor: "white",
        borderRadius: "3px"
    },

    tableManagementContainer__primaryIconButton: {
        height: "32px",
        padding: "0 12px",
        paddingLeft: "6px",

        border: "none",
        borderRadius: "4px",

        fontSize: "16px",
        color: "white",
        backgroundColor: "#C3996B",

        display: "flex",
        gap: "4px",
        alignItems: "center",

        transition: "all 0.2s ease-in-out",

        // [theme.breakpoints.down('sm')]: {
        //     height: "40px",
        //     paddingLeft: "8px",
        // },

        "&:hover": {
            backgroundColor: "#a77d4f",
            color: "white",
            cursor: "pointer",
        }
    },

    primaryIconButton: {
        height: "40px",
        padding: "0 16px",
        paddingLeft: "8px",

        border: "none",
        borderRadius: "4px",

        fontSize: "16px",
        color: "white",
        backgroundColor: "#C3996B",

        display: "flex",
        gap: "8px",
        alignItems: "center",

        transition: "all 0.2s ease-in-out",

        "&:hover": {
            backgroundColor: "#a77d4f",
            color: "white",
            cursor: "pointer",
        }
    },

    iconButton__icon: {
        height: "20px",
        width: "20px",

        display: "block",
    },

    linkButton: {
        color: 'white !important',
        background: "#C3996B !important",
        border: "1px solid #C3996B !important",
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        transition: '0.3s',
        "&:hover": {
            background: "rgba(195, 153, 107, 0.85) !important",

        },
    },
    cardGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(1, 1fr)', // Default to 1 column on small screens
        gap: '16px', // Space between grid items
        borderRadius: "8px",
        marginRight: "auto",
        marginLeft: "auto",
        marginBottom: "24px",

        // Increase to 2 columns on medium screens
        [theme.breakpoints.up('md')]: {
            backgroundColor: "green",
            gridTemplateColumns: 'repeat(2, 1fr)',
        },

        // Max 3 columns on large screens
        [theme.breakpoints.up('lg')]: {
            gridTemplateColumns: 'repeat(3, 1fr)',
        },
    },

    card: {
        display: "flex",
        flexDirection: "column", // Keep items stacked within each box
        background: "#FFFFFF",
        borderRadius: "8px",
        padding: "16px",
        gap: "8px",

        width: '100%',
        height: "190px",

        transition: "scale 0.2s ease-in-out",

        "&:hover": {
            cursor: "pointer",
            scale: "1.02",
        }
    },

    card__create: {
        display: "flex",
        flexDirection: "column", // Keep items stacked within each box
        background: "#FFFFFF",
        borderRadius: "8px",
        padding: "16px",
        gap: "8px",

        width: '100%',
        height: "190px",

        transition: "scale 0.2s ease-in-out",

        "&:hover": {
            cursor: "pointer",
            scale: "1.02",
        }
    },

    card__header: {
        width: '100%',
        maxHeight: '25%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'row',
    },

    cardTitle: {
        fontFamily: "Lato, sans-serif",
        fontSize: "24px",
        fontWeight: "normal",
        lineHeight: "normal",
        margin: "0",
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'block',
        whiteSpace: 'nowrap'
    },

    card__body: {
        width: "100%",
        height: "100%",

        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        gap: "16px",
    },

    card__description: {
        margin: "0",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        WebkitLineClamp: 3, // Number of lines to display before ellipsis
        WebkitBoxOrient: "vertical",
        lineHeight: "1.5em", // Adjust based on desired spacing
        maxHeight: "4.5em", // Should match lineHeight * WebkitLineClamp
    },

    card__footer: {
        width: "100%",
        // fontWeight: "400",
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "space-between",
    },

    card__details: {
        display: "flex",
        alignItems: "center",
        gap: "16px",
    },

    card__date: {
        width: 'fit-content',
        display: "flex",
        alignItems: "center",
        gap: "4px",
    },

    detail__icon: {
        height: "20px",
        width: "20px",

        display: "block",

        strokeWidth: "1.4px",
    },

    card__company: {
        width: 'fit-content',
        justifyContent: 'center',
        display: "flex",
        alignItems: "center",
        gap: "4px",
    },

    statusIndicator: {
        width: "8px",
        height: "8px",
        borderRadius: "50%",
        display: "inline-block",
    },

    // Style for published indicator (green)
    published: {
        backgroundColor: "#5CC958",
    },

    // Style for not published indicator (red)
    notPublished: {
        backgroundColor: "#D84949",
    },

    primaryButton: {
        height: "40px",
        padding: "0 16px",

        border: "none",
        borderRadius: "4px",

        fontSize: "16px",
        color: "white",
        backgroundColor: "#C3996B",

        transition: "all 0.2s ease-in-out",

        "&:hover": {
            backgroundColor: "#a77d4f",
            cursor: "pointer",
        }
    },

    buttonContainer: {
        display: 'flex',
        alignContent: 'center',
        flexDirection: 'row',
    },

    buttonContainer__icon: {
        width: "20px",
        height: "20px",
        strokeWidth: "1.4px",
        color: "#0C0E29"
    },

    dialog: {
        margin: "auto"
    },

    dialogPaper: {
        width: '320px !important',
        height: 'auto',
        borderRadius: '6px !important',
    },

    dialog__head: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',

        padding: '16px 16px 0px 16px !important',
        marginBottom: '8px !important',
    },

    dialog__title: {
        fontSize: '24px !important',
        fontFamily: "Lato, sans-serif !important",
        fontWeight: 'normal',

        lineHeight: '100% !important',

        padding: '0px !important',
    },

    dialog__closeButton: {
        backgroundColor: '#F5F5F5',
        border: 'none',
        cursor: 'pointer',

        padding: '3px !important',
        height: '25px !important',

        borderRadius: '3px',

        transition: 'all 0.2s',

        '&:hover': {
            backgroundColor: '#D84949',
            color: '#F5F5F5',
        },

        '&:focus-visible': {
            outline: '#4654FB auto 1px',
        },
    },

    dialog__subtitle: {
        fontSize: '16px',
        fontFamily: "Lato, sans-serif",
        fontWeight: 'normal',

        color: '#0C0E29',

        margin: '0px 0px 8px 0px',
    },

    dialog__contentContainer: {
        padding: '0px 16px !important',
        marginBottom: "8px",

        // remove scrollbar
        '&::-webkit-scrollbar': {
            display: 'none',
        },
        '-ms-overflow-style': 'none',
        scrollbarWidth: 'none',
    },

    dialog__content: {
        display: 'flex',
        height: '100%',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',

        margin: '0px !important',
    },

    deleteButton: {
        height: "40px",
        padding: "0 16px",
        paddingLeft: "8px",

        border: "none",
        borderRadius: "4px",

        fontSize: "16px",
        color: "#FDF3F3",
        backgroundColor: "#D84949",

        display: "flex",
        gap: "8px",
        alignItems: "center",

        transition: "all 0.2s ease-in-out",

        "&:hover": {
            backgroundColor: "#C73B3B",
            color: "FDF3F3",
            cursor: "pointer",
        }
    },

    secondaryButton: {
        height: "40px",
        padding: "0 16px",

        border: "1px solid #C3996B",
        borderRadius: "4px",

        fontSize: "16px",
        color: "#C3996B",
        backgroundColor: "transparent",

        transition: "all 0.2s ease-in-out",

        userSelect: "none",

        "&:hover": {
            backgroundColor: "#a77d4f",
            color: "white",
            border: "1px solid #a77d4f",
            cursor: "pointer",
        }
    },
}));